import React from "react"

import { ProjectPageRoomSidebar } from "pages/project-page/sidebar/room/ProjectPageRoomSidebar"
import {
  UseSharedProjectPageRoomSidebarModelArgs,
  useSharedProjectPageRoomSidebarModel
} from "pages/project-page/sidebar/room/hooks/useSharedProjectPageRoomSidebarModel"

export const SharedProjectPageRoomSidebarConnector = React.memo(
  (props: UseSharedProjectPageRoomSidebarModelArgs) => (
    <ProjectPageRoomSidebar
      id="room-sidebar-form"
      {...useSharedProjectPageRoomSidebarModel(props)}
      hideControls
    />
  )
)
